/**
 * @module
 * @format
 */

/**
 * @import {Amateur} from '../amateurPool/model/amateur.js';
 * @import {Movie} from "../moviePool/model/movie.js"
 * @import {PictureSet} from "../picturePool/model/picture-set.js"
 * @import {ImageFormat} from '../ts/core/image.ts';
 * @import {WeblogController, WeblogData} from './types'
 */

import {UPGRADE} from '@acng/frontend-stargazer';
import {add} from '@acng/frontend-bounty/style/element.js';
import {media} from '../core/service/env.js';
import {frigg} from '../model';
import {user} from '../user/user.js';

/**
 * @implements {WeblogController}
 */
class Weblog {
  #data;
  #creator;
  #gallery;

  /**
   * @param {WeblogData} data
   * @param {Amateur} creator
   * @param {Movie | PictureSet} [gallery]
   */
  constructor(data, creator, gallery) {
    this.id = data.id;
    this.#data = data;
    this.#creator = creator;
    this.#gallery = gallery;
  }

  get title() {
    return this.#data.title;
  }

  get text() {
    return this.#data.content;
  }

  get creator() {
    return this.#creator;
  }

  get dateCreated() {
    return new Date(this.#data.created);
  }

  get url() {
    return this.#gallery?.url ?? this.#creator.url;
  }

  /**
   * @param {ImageFormat} [format]
   */
  @frigg getImageUrl(format) {
    const {image, image_fsk} = this.#data;

    if (!image || user.fsk < (image_fsk ?? 18)) {
      return this.#gallery?.getImageUrl() ?? this.#creator.getImageUrl(format ?? '800');
    }

    return `${media.content.pictures}${image}`;
  }

  /**
   * @param {Element} element
   */
  [UPGRADE](element) {
    if (!this.#gallery) {
      add(element, 'without-media');

      if (!this.#data.image) {
        add(element, 'without-image');
      }
    }
  }
}

export {Weblog};
